<template>
  <div class="plc-search">
    <input
      :placeholder="placeholder"
      :value="modelValue"
      type="search"
      class="plc-search__input"
      @input="$emit('update:modelValue', $event.target.value)"
      @keyup.enter="handleSearch"
    />
    <div class="plc-search__addon">
      <gl-button variant="light" class="plc-search__btn" @click="handleSearch">Search</gl-button>
    </div>
  </div>
</template>

<script>
import GlButton from '@gl/GlButton'

export default {
  name: 'HeaderSearchDesktop',
  components: { GlButton },
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue', 'change'],
  methods: {
    handleSearch() {
      this.$emit('change')
    },
  },
}
</script>

<style lang="scss" scoped>
.plc-search {
  position: relative;

  &__input {
    @include placeholder(rgba(255, 255, 255, 0.37));

    background-color: rgba(255, 255, 255, 0.07);
    border: 2px solid transparent;
    border-radius: 20px;
    color: #fff;
    flex-grow: 1;
    font-family: $font-family;
    font-size: 14px;
    height: 40px;
    outline: none;
    padding: 0 24px;
    text-overflow: ellipsis;
    width: 100%;

    @media (min-width: $breakpoint-md) {
      padding-right: 150px; // 150px - default width of button
    }

    &:focus {
      border: 2px solid $color-primary;
    }

    &::-webkit-search-cancel-button {
      /* stylelint-disable-next-line */
      -webkit-appearance: none;
    }
  }

  &__addon {
    margin-top: 8px;

    @media (min-width: $breakpoint-md) {
      margin-top: 0;
      position: absolute;
      right: 0;
      top: 0;
      width: auto;
    }
  }

  &__btn {
    width: 100%;

    @media (min-width: $breakpoint-md) {
      width: auto;
    }
  }
}
</style>
